
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { FormState__startLoading, FormState_get_empty } from "./Shared/Shared.js";
import { Requests_UpdateNewsletterConsentDto_$reflection, Requests_UpdateNewsletterConsentDto } from "./Shared/User.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "./fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "./CommunicationV2.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { filter, length, singleton, ofArray } from "./fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "./fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { list_type, obj_type } from "./fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Dialog } from "./Components/Dialog.js";
import { equals, defaultOf, createObj } from "./fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "./fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { TextButton } from "./Components/Button.js";
import { savePanel, loadPanel } from "./ActivityBar/Storage.js";
import { ActivityPanel, SupportWidgetState } from "./ActivityBar/Types.js";
import { Feature, isFeatureEnabled } from "./FeatureFlip.js";
import swr from "swr";
import { notificationsKey } from "./Widgets/Notification/Notification.js";
import { OverviewNotification_$reflection } from "./Shared/Notification.js";
import { ValidationOnGetRequest } from "./ErrorHandling.js";
import { ChatConversationDto_$reflection } from "./Shared/Chat.js";
import { unwrap, some, map, defaultArg } from "./fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { useCountingTasks } from "./Widgets/StocktakingCountingTasks.js";
import { isUnread, getLastReadTimestamps } from "./Chat/Overview/UnreadTracking.js";
import { relayout, loadInline } from "./HubSpotChat.js";
import { embedContainerId } from "./ActivityBar/SupportPanel.js";
import { toast } from "react-hot-toast";
import { withoutOnboardingTourQueryParams, isTenantsOnboardingTourPhase } from "./Common.js";
import { RouterModule_encodeQueryString, RouterModule_nav } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { empty, singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Navigation, TopNavigation } from "./Navigation.js";
import { ViewContainer } from "./Components/ViewContainer.js";
import { FloatingDialog } from "./Widgets/FloatingDialog.js";
import { toLocalTime, toString as toString_1 } from "./fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { ActivityPanelView } from "./ActivityBar/Panel.js";
import { ActivityRail } from "./ActivityBar/Rail.js";
import { TourGuideLocale, TourStep, TourGuide } from "./Components/TourGuide.js";

export function NewsletterConsentDialog(props) {
    let Title, elems;
    const t = useTranslation()[0];
    let patternInput_1;
    const initial = props.CurrentUser.NewsletterConsent == null;
    patternInput_1 = reactApi.useState(initial);
    const setIsOpen = patternInput_1[1];
    let patternInput_2;
    const initial_1 = FormState_get_empty();
    patternInput_2 = reactApi.useState(initial_1);
    const setFormState = patternInput_2[1];
    const formState = patternInput_2[0];
    const componentState = formState.IsLoading ? "disabled" : "enabled";
    const saveConsent = (consent) => {
        const dto = new Requests_UpdateNewsletterConsentDto(consent);
        const body = toString(0, Auto_generateBoxedEncoder_437914C6(Requests_UpdateNewsletterConsentDto_$reflection(), undefined, undefined, undefined)(dto));
        setFormState(FormState__startLoading(formState));
        let pr_3;
        let pr_2;
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let url_1;
            return ((url_1 = addPrefix("/api/users/newsletter-consent"), (refreshOn) => fetchWithDecoder(url_1, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [body])]), "application/json", (response) => {
                const pr = response.arrayBuffer();
                return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), obj_type));
            }, refreshOn)))(true);
        }));
        pr_2 = (pr_1.then((_arg) => {
            setFormState(FormState_get_empty());
            setIsOpen(false);
        }));
        pr_3 = (pr_2.then(void 0, ((_arg_1) => {
            setFormState(FormState_get_empty());
        })));
        pr_3.then();
    };
    return createElement(Dialog, (Title = t("user.newsletter.dialog_title"), {
        Body: singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4", "grid", "gap-2"])], (elems = [reactElement("p", {
            children: t("user.newsletter.dialog_description_1"),
        }), reactElement("p", {
            children: t("user.newsletter.dialog_description_2"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: componentState,
            Label: t("user.newsletter.decline"),
            OnClick: () => {
                saveConsent(false);
            },
            TestId: "newsletter-consent-decline-button",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: componentState,
            Label: t("user.newsletter.accept"),
            OnClick: () => {
                saveConsent(true);
            },
            TestId: "newsletter-consent-accept-button",
            Variant: "blueButton",
        })]),
        IsOpen: patternInput_1[0],
        OnClose: () => {
            if (!formState.IsLoading) {
                setIsOpen(false);
            }
        },
        Title: Title,
    }));
}

export function NavigationContainer(props) {
    let elems_2;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(true);
    const isDialogVisible = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const navigationMinimized = patternInput_2[0];
    const patternInput_3 = reactApi.useState(false);
    const setTenantsTourDismissed = patternInput_3[1];
    const patternInput_4 = reactApi.useState(() => loadPanel(props.UserData.UserId));
    const storedPanel = patternInput_4[0];
    const setStoredPanel = patternInput_4[1];
    const patternInput_5 = reactApi.useState(new SupportWidgetState(0, []));
    const supportWidgetState = patternInput_5[0];
    const setSupportWidgetState = patternInput_5[1];
    const patternInput_6 = reactApi.useState(0);
    const supportUnreadCount = patternInput_6[0] | 0;
    const previousSupportUnreadCount = reactApi.useRef(0);
    const showChat = props.AccountSettings.ChatEnabled && props.Configuration.ChatActive;
    const showSupport = props.HubSpotChatSettings != null;
    const showHelp = isFeatureEnabled(new Feature(10, []));
    const activePanel = (storedPanel != null) ? ((storedPanel.tag === 1) ? (!showChat ? undefined : storedPanel) : ((storedPanel.tag === 2) ? (!showSupport ? undefined : storedPanel) : ((storedPanel.tag === 3) ? (!showHelp ? undefined : storedPanel) : storedPanel))) : storedPanel;
    const closePanel = () => {
        setStoredPanel(undefined);
    };
    const notificationsResponse = swr(notificationsKey, (url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(OverviewNotification_$reflection())));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), {
        refreshInterval: 60000,
    });
    const chatResponse = swr(showChat ? "/api/chat" : defaultOf(), (url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_5;
        return ((url_5 = addPrefix(url_3), (refreshOn_1) => fetchWithDecoder(url_5, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_2) => {
            const pr_1 = response_2.arrayBuffer();
            return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(ChatConversationDto_$reflection())));
        }, refreshOn_1)))(true).then((_arg_1) => {
            const result_3 = _arg_1;
            return (result_3.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_3.fields[0]);
            })())) : (Promise.resolve(result_3.fields[0]));
        });
    })), {
        refreshInterval: 5000,
    });
    let notificationCount;
    const y = defaultArg(map((list) => (length(list) | 0), notificationsResponse.data), 0) | 0;
    notificationCount = (length(useCountingTasks(props.AccountSettings)) + y);
    let chatUnreadCount;
    const matchValue = chatResponse.data;
    if (matchValue == null) {
        chatUnreadCount = 0;
    }
    else {
        const conversations = matchValue;
        const lastReadMap = getLastReadTimestamps(props.UserData.UserId);
        chatUnreadCount = length(filter((conversation) => isUnread(props.UserData.UserName, lastReadMap, conversation), conversations));
    }
    const dependencies = [storedPanel];
    reactApi.useEffect(() => {
        savePanel(props.UserData.UserId, storedPanel);
    }, dependencies);
    const dependencies_2 = [activePanel, showSupport, supportWidgetState];
    reactApi.useEffect(() => {
        const matchValue_1 = props.HubSpotChatSettings;
        let matchResult, settings;
        if (matchValue_1 != null) {
            switch (supportWidgetState.tag) {
                case 0: {
                    matchResult = 0;
                    settings = matchValue_1;
                    break;
                }
                case 2: {
                    if (equals(activePanel, new ActivityPanel(2, []))) {
                        matchResult = 1;
                    }
                    else {
                        matchResult = 2;
                    }
                    break;
                }
                default:
                    matchResult = 2;
            }
        }
        else {
            matchResult = 2;
        }
        switch (matchResult) {
            case 0: {
                setSupportWidgetState(new SupportWidgetState(1, []));
                loadInline(settings, concat("#", ...embedContainerId), {
                    OnFailed: () => {
                        setSupportWidgetState(new SupportWidgetState(4, []));
                    },
                    OnHidden: (description) => {
                        console.warn(some("HubSpot-Support-Chat nicht angezeigt: " + description));
                        setSupportWidgetState(new SupportWidgetState(3, []));
                    },
                    OnLoaded: () => {
                        setSupportWidgetState(new SupportWidgetState(2, []));
                    },
                    OnUnreadCountChanged: patternInput_6[1],
                });
                break;
            }
            case 1: {
                relayout();
                break;
            }
            case 2: {
                break;
            }
        }
    }, dependencies_2);
    const dependencies_4 = [supportUnreadCount];
    reactApi.useEffect(() => {
        if ((supportUnreadCount > previousSupportUnreadCount.current) && !equals(activePanel, new ActivityPanel(2, []))) {
            toast.success(t("activity_bar.support_new_reply"));
        }
        previousSupportUnreadCount.current = supportUnreadCount;
    }, dependencies_4);
    const showTenantsTour = isTenantsOnboardingTourPhase() && !patternInput_3[0];
    const clearTenantsOnboardingTourFromUrl = () => {
        RouterModule_nav(singleton("dashboard" + RouterModule_encodeQueryString(withoutOnboardingTourQueryParams())), 1, 1);
    };
    return reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton_1("grid"), delay(() => append(navigationMinimized ? singleton_1("grid-cols-[5rem_2px_minmax(0,1fr)_auto_auto]") : singleton_1("grid-cols-[16rem_2px_minmax(0,1fr)_auto_auto]"), delay(() => append(singleton_1("print:flex"), delay(() => append(singleton_1("grid-rows-[4rem,calc(100vh-4rem)]"), delay(() => append(singleton_1("h-100"), delay(() => append(singleton_1("grow"), delay(() => (navigationMinimized ? singleton_1("relative") : empty()))))))))))))))))], (elems_2 = toList(delay(() => append(singleton_1(createElement(TopNavigation, {
        AccountSettings: props.AccountSettings,
        Configuration: props.Configuration,
        CurrentUser: props.CurrentUser,
        OnLogout: props.OnLogout,
        SubTestId: unwrap(props.SubTestId),
        SubTitle: unwrap(props.SubTitle),
        TestId: props.TestId,
        Title: props.Title,
        ToggleNavigationMinimized: () => {
            patternInput_2[1](!navigationMinimized);
        },
        UserData: props.UserData,
        Username: props.CurrentUser.Name,
    })), delay(() => append(navigationMinimized ? singleton_1(reactElement("div", {
        className: join(" ", ["row-start-1", "row-span-2", "col-start-1", "bg-white"]),
    })) : empty(), delay(() => append(singleton_1(createElement(Navigation, {
        AccountSettings: props.AccountSettings,
        CurrentUrl: props.CurrentUrl,
        CurrentUser: props.CurrentUser,
        CustomerConfiguration: props.Configuration,
        IsInTestphase: props.IsInTestphase,
        NavigationMinimized: navigationMinimized,
        Permissions: props.Permissions,
        UserData: props.UserData,
    })), delay(() => append(singleton_1(reactElement("div", {
        className: join(" ", ["row-start-1", "row-span-2", "min-w-[2px]", "bg-divider"]),
    })), delay(() => {
        let elems_1;
        return append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["row-start-2", "col-start-3", "grow", "flex", "flex-col", "bg-background", "relative", "w-full", "min-w-0"])], (elems_1 = toList(delay(() => append(singleton_1(createElement(ViewContainer, {
            Children: props.SubView,
        })), delay(() => {
            let matchValue_3, elems, Text$;
            return append(isDialogVisible ? ((matchValue_3 = props.AccountSettings.AccountState, (matchValue_3 === "testPeriodEnded") ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["w-248", "bottom-10", "left-[50%]", "translate-x-[-50%]", "bg-transpatent", "grid-cols-2", "absolute"])], (elems = [createElement(FloatingDialog, (Text$ = t("dashboard.testphasemodal"), {
                Date: defaultArg(map((accountEndDate) => toString_1(toLocalTime(accountEndDate), "dd.MM.yyyy"), props.AccountSettings.AccountEndDate), ""),
                OnCancelClick: () => {
                    patternInput_1[1](!isDialogVisible);
                },
                OnClick: () => {
                    RouterModule_nav(ofArray(["customer", "wizard"]), 1, 1);
                },
                Text: Text$,
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : ((matchValue_3 === "testPeriodActive") ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["w-248", "bottom-10", "left-[50%]", "translate-x-[-50%]", "bg-transpatent", "grid-cols-2", "absolute"])], (elems = [createElement(FloatingDialog, (Text$ = t("dashboard.testphasemodal"), {
                Date: defaultArg(map((accountEndDate) => toString_1(toLocalTime(accountEndDate), "dd.MM.yyyy"), props.AccountSettings.AccountEndDate), ""),
                OnCancelClick: () => {
                    patternInput_1[1](!isDialogVisible);
                },
                OnClick: () => {
                    RouterModule_nav(ofArray(["customer", "wizard"]), 1, 1);
                },
                Text: Text$,
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : (empty())))) : empty(), delay(() => singleton_1(createElement(NewsletterConsentDialog, {
                CurrentUser: props.CurrentUser,
            }))));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => append(singleton_1(createElement(ActivityPanelView, {
            AccountSettings: props.AccountSettings,
            ActivePanel: unwrap(activePanel),
            CurrentUser: props.CurrentUser,
            OnClose: closePanel,
            SupportWidgetState: supportWidgetState,
            UserData: props.UserData,
        })), delay(() => append(singleton_1(createElement(ActivityRail, {
            ActivePanel: unwrap(activePanel),
            ChatUnreadCount: chatUnreadCount,
            NotificationCount: notificationCount,
            OnClose: closePanel,
            OnSelect: (panel_1) => {
                setStoredPanel(equals(activePanel, panel_1) ? undefined : panel_1);
            },
            ShowChat: showChat,
            ShowHelp: showHelp,
            ShowSupport: showSupport,
            SupportUnreadCount: supportUnreadCount,
        })), delay(() => {
            let Steps;
            return showTenantsTour ? singleton_1(createElement(TourGuide, (Steps = singleton(new TourStep("[data-test-id=\'top-navigation-user-menu\']", t("onboarding.tour.tenants_user_menu_title"), reactElement("div", {
                children: t("onboarding.tour.tenants_user_menu_content"),
            }), "bottom", true)), {
                IsRunning: true,
                Locale: new TourGuideLocale(t("onboarding.tour.joyride_back"), t("onboarding.tour.joyride_close"), t("onboarding.tour.joyride_last"), t("onboarding.tour.joyride_next"), t("onboarding.tour.joyride_next_with_progress"), t("onboarding.tour.joyride_open"), t("onboarding.tour.joyride_skip")),
                OnFinish: () => {
                    setTenantsTourDismissed(true);
                    clearTenantsOnboardingTourFromUrl();
                },
                OnSkip: () => {
                    setTenantsTourDismissed(true);
                    clearTenantsOnboardingTourFromUrl();
                },
                ScrollFirstStep: true,
                Steps: Steps,
            }))) : empty();
        }))))));
    })))))))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

